import { Route, Routes } from 'react-router-dom';
import CreateProgram from '../components/create-program/Create-program';
import { CrearObra } from '../components/crear-Obra/CrearObra';

export const RoutesCreateObra = ({ isUpdated }: any) => {
  return (
    <>
      <Routes>
        <Route path='/' element={<CreateProgram isUpdated={true} />} />
        <Route path=':id/:year/:month' element={<CrearObra />} />
      </Routes>
    </>
  );
};
